import { api } from "@/shared/lib/axios/axios.api"
import {
  API_SUBSCRIPTIONS_PREFIX,
  BILLING_API_PREFIX,
  MT_API_PREFIX,
} from "@/shared/lib/axios/axios.constants"
import { handleAxiosError } from "@/shared/lib/axios/axios.lib"
import { isAxiosError } from "axios"
import { SubscriptionId } from "./subscription.types"

export const getUsageInfo = async (): Promise<string> => {
  try {
    const response = await api.get<string>(`${MT_API_PREFIX}/contracts/usage`)
    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}

// api subscription
export const getApiSubscriptionList = async () => {
  try {
    const response = await api.get(API_SUBSCRIPTIONS_PREFIX)

    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const makeApiSubscription = async () => {
  try {
    const response = await api.post(`${BILLING_API_PREFIX}/api-subscriptions`)

    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}

// Staff only: the server refuses anyone without an admin role.
export const grantInternalApiSubscription = async () => {
  try {
    const response = await api.post(`${API_SUBSCRIPTIONS_PREFIX}/internal`)

    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const unsubscribeApiSubscription = async ({
  subscriptionId,
}: SubscriptionId) => {
  try {
    const response = await api.patch(API_SUBSCRIPTIONS_PREFIX, {
      subscriptionId,
    })

    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const undoApiUnsubscribe = async ({
  subscriptionId,
}: SubscriptionId) => {
  try {
    const response = await api.patch(`${API_SUBSCRIPTIONS_PREFIX}/undo`, {
      subscriptionId,
    })

    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}

// The server refused to issue a key because one exists: the request asked for a
// first key only (onlyIfNoKey), and a key was issued meanwhile.
export class ApiKeyAlreadyIssuedError extends Error {}

export const issueApiSubscriptionKey = async ({
  subscriptionId,
  onlyIfNoKey = false,
}: SubscriptionId & { onlyIfNoKey?: boolean }) => {
  try {
    const response = await api.post(`${API_SUBSCRIPTIONS_PREFIX}/keys`, {
      subscriptionId,
      onlyIfNoKey,
    })

    return response.data
  } catch (error) {
    // Checked before handleAxiosError, which turns a plain-text body into an
    // Error and drops the status.
    if (onlyIfNoKey && isAxiosError(error) && error.response?.status === 409) {
      throw new ApiKeyAlreadyIssuedError()
    }
    return handleAxiosError(error)
  }
}
